import { render, staticRenderFns } from "./CompliantLegend.vue?vue&type=template&id=c30865b0&"
import script from "./CompliantLegend.vue?vue&type=script&lang=js&"
export * from "./CompliantLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports